import { glyphWalletConnector } from "@use-glyph/sdk-react"
import type { CreateConnectorFn } from "wagmi"

export function glyphConnector() {
  return glyphWalletConnector() as CreateConnectorFn
}
